import React from 'react'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { transferInstalment } from 'services/fund'

export default function useUpdateInstallment() {
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: {
            source_instalment_id:  string| undefined
            destination_instalment_index: number
            amount: number
            moneyPools: string | undefined
            loans: string | undefined
        }) => {
            return transferInstalment(payload)
        },
        onSuccess: (data) => {
            toast.success('  با موفقیت تغییر یافت')
            navigate(-1)
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { isLoading, mutate }
}
